// test1799
(1799 && 0);
